<template>
    <div class="map-container" :style="containerStyleObj">
        <div id="china_map" class="map-main" ref="chinaMapRef" :style="mapStyleObj"></div>
        <div class="panel-box-wrap" v-show="isShowProvince">
            <div class="close-btn">
                <img class="logo-img" src="../../../assets/images/map/close.png" width="100%" height="100%"
                     v-on:click="closeWin"/>
            </div>
            <div class="panel-box">
                <div class="panel-left" ref="panelLeftRef">
                    <div id="province_map" ref="provinceMapRef" class="left-map"></div>
                </div>
                <div class="panel-right">
                    <div class="panel-head">
                        <div class="head-wrap">
                            <div class="right-mian" style="display: flex">
                                <input placeholder="请输入学校名称" class="input-cla" v-model="filters.keyWord"
                                       v-on:keyup.enter="handleSearch"/>
                                <div class="search-btn" v-on:click="handleSearch">
                                    <div class="search-icon">
                                        <img src="../../../assets/images/databoard/detailPage/search.png" width="100%"
                                             height="100%"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--按学校统计的学校使用情况列表-->
                    <div class="panel-table" v-if="typeTag===1">
                        <div class="header">
                            <Col :span="3">
                            <span>排序</span>
                            </Col>
                            <Col :span="10">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="5">
                            <span>学段</span>
                            </Col>
                            <Col :span="6">
                            <span>班级数</span>
                            </Col>
                        </div>
                        <Row class="row-wrap" v-for="(item,index) in schoolUseData" :key="item.id">
                            <Col :span="3" class="col-content">
                            <div class="sort-item orange-item"
                                 :class="(pageParams.page-1) * pageParams.limit + index++ <3 ? 'orange-item':'blue-item'">
                                <span>{{(pageParams.page-1) * pageParams.limit + index++}}</span>
                            </div>
                            </Col>
                            <Col :span="10" class="col-content">
                            <!-- v-if="item.state==1"-->
                            <a :title="item.school_name" href="javascript:void(0);"
                               v-on:click="lookSchoolDashBoard(item.id)"
                               style="color: #2d8cf0;">{{item.school_name}}</a>
                            <!--<span v-else>{{item.school_name}}</span>-->
                            </Col>
                            <Col :span="5" class="col-content">
                            <span>{{item.phase}}</span>
                            </Col>
                            <Col :span="6" class="col-content">
                            <span>{{item.classCount}}</span>
                            </Col>
                        </Row>
                    </div>
                    <!--按用户统计的学校使用情况列表-->
                    <div class="panel-table" v-else>
                        <div class="header">
                            <Col :span="3">
                            <span>排序</span>
                            </Col>
                            <Col :span="10">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="3">
                            <span>学段</span>
                            </Col>
                            <Col :span="4">
                            <span>班级数</span>
                            </Col>
                            <Col :span="4">
                            <span>用户数</span>
                            </Col>
                        </div>
                        <Row class="row-wrap" v-for="(item,index) in schoolUseData" :key="item.id">
                            <Col :span="3" class="col-content">
                            <div class="sort-item orange-item"
                                 :class="(pageParams.page-1) * pageParams.limit + index++ <3 ? 'orange-item':'blue-item'">
                                <span>{{(pageParams.page-1) * pageParams.limit + index++}}</span>
                            </div>
                            </Col>
                            <Col :span="10" class="col-content">
                            <!-- v-if="item.state==1"-->
                            <a :title="item.school_name" href="javascript:void(0);"
                               v-on:click="lookSchoolDashBoard(item.id)"
                               style="color: #2d8cf0;">{{item.school_name}}</a>
                            <!--<span v-else>{{item.school_name}}</span>-->
                            </Col>
                            <Col :span="3" class="col-content">
                            <span>{{item.phase}}</span>
                            </Col>
                            <Col :span="4" class="col-content">
                            <span>{{item.classCount}}</span>
                            </Col>
                            <Col :span="4" class="col-content">
                            <span>{{item.userCount}}</span>
                            </Col>
                        </Row>
                    </div>
                    <div class="bottom-page">
                        <div class="laypage_main">
                            <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                                  v-if="pageParams.total && pageParams.pageCount>1"></Page>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {findCityData, findSchoolUserList} from "../../../service/api.js";

    export default {
        name: "china-map",
        props: {
            chinaData: Array,
            typeTag: Number,
            fromTag: Number
        },
        data() {
            return {
                provinces: ['shanghai', 'hebei', 'shanxi', 'neimenggu', 'liaoning', 'jilin', 'heilongjiang', 'jiangsu', 'zhejiang', 'anhui', 'fujian', 'jiangxi', 'shandong', 'henan', 'hubei', 'hunan', 'guangdong', 'guangxi', 'hainan', 'sichuan', 'guizhou', 'yunnan', 'xizang', 'shanxi1', 'gansu', 'qinghai', 'ningxia', 'xinjiang', 'beijing', 'tianjin', 'chongqing', 'xianggang', 'aomen', 'taiwan'],//一级省市
                provincesText: ['上海', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '北京', '天津', '重庆', '香港', '澳门', '台湾'],//一级省市名称
                isShowProvince: false,//显示二级省区统计图
                map: null,//中国地图
                mapData: [],
                maxNum: 0,
                geoCoordMap: {},
                provinceMap: null,//省级地图
                provinceMapData: [],
                currentProvinceName: '',//省名称
                currentProvinceCode: '',//省code
                currentCityCode: '',//市code
                mapStyleObj: {
                    width: '100%',
                    height: '100%'
                },
                containerStyleObj: {
                    height: ''
                },
                schoolUseData: [],//学校使用数据
                filters: {
                    keyWord: ''
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                }
            }
        },
        watch: {
            chinaData(val) {
                let _this = this;
                _this.map.setOption({
                    series: [{
                        data: _this.convertData(val)
                    },
                        {
                            data: val
                        }],
                    visualMap: {
                        max: _this.findMaxVal(val)
                    }
                });

                //执行父页面的数字滚动加载
                _this.$emit('scroll-total-num');
            },
            provinceMapData(val) {
                let _this = this;
                _this.provinceMap.setOption({
                    series: [{
                        data: val
                    }],
                    visualMap: {
                        max: _this.findMaxVal(val)
                    }
                });
            }
        },
        methods: {
            /**
             * 翻页
             */
            handleCurrentChange(val) {
                this.pageParams.page = val;
                this.getSchoolUseList(this.currentProvinceCode, this.currentCityCode);
            },
            /**
             * 查询
             */
            handleSearch() {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.getSchoolUseList(this.currentProvinceCode, this.currentCityCode);
            },
            /**
             * 初始化地图经纬度数据
             */
            getGeoData() {
                let _this = this;

                /*获取地图数据*/
                var mapFeatures = this.$echarts.getMap('china').geoJson.features;
                mapFeatures.forEach(function (v) {
                    // 地区名称
                    var name = v.properties.name;
                    // 地区经纬度
                    _this.geoCoordMap[name] = v.properties.cp;
                });
            },
            /**
             * 各地区经纬度，数值data
             */
            convertData(data) {
                let _this = this;

                var res = [];
                for (var i = 0; i < data.length; i++) {
                    var geoCoord = _this.geoCoordMap[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            code: data[i].code,
                            value: geoCoord.concat(data[i].value)
                        });
                    }
                }
                return res;
            },
            /**
             * 获取最大数值
             */
            findMaxVal(data) {
                let curMaxNum = 0;
                for (var i = 0; i < data.length; i++) {
                    if (curMaxNum < data[i].value) {
                        curMaxNum = data[i].value;
                    }
                }
                return curMaxNum;
            },
            /**
             * 关闭弹窗
             */
            closeWin() {
                this.filters.keyWord = '';
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.provinceMapData = [];
                this.currentProvinceName = '';
                this.currentProvinceCode = '';
                this.currentCityCode = '';
                this.isShowProvince = false;
            },
            /**
             * 加载省地图
             */
            initProviceMap(provice, proviceName) {
                let _this = this;
                require('echarts/map/js/province/' + provice + '.js');
                _this.provinceMap.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            if (params.seriesType === 'map') {
                                if (params.name == '') {
                                    return;
                                }
                                if (!isNaN(params.value)) {
                                    return params.name + ' : ' + params.value;
                                }
                            } else if (params.seriesType === 'scatter') {
                                return params.name + ' : ' + params.value[2];
                            } else if (params.seriesType === 'effectScatter') {
                                return params.name + ' : ' + params.value[2];
                            } else {
                                return '暂无数据';
                            }
                        }
                    },
                    title: {
                        text: _this.currentProvinceName,
                        left: '50px',
                        textStyle: {
                            color: '#0EFCFF',
                            fontSize: 24
                        }
                    },
                    geo: {
                        map: proviceName,
                        roam: false,
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: '#fff'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaColor: '#b2c7ff',
                                borderColor: 'rgba(0, 0, 0, 0.2)'
                            }
                        },
                        emphasis: {
                            label: {
                                show: true,
                                color: '#fff'
                            },
                            itemStyle: {
                                areaColor: '#29ACE2',
                            }
                        }
                    },
                    // 视觉映射组件
                    // visualMap: {
                    //     show: false, // 省级不显示
                    //     type: 'piecewise',
                    //     pieces: [
                    //         {gt: 1000, label: '1000 以上'},
                    //         {gt: 500, lte: 1000},
                    //         {gt: 100, lte: 500},
                    //         {gt: 0, lt: 100}
                    //     ],
                    //     color: ['#b2c7ff', '#7398ff', '#4073ff', '#1957ff'],
                    //     textStyle: {
                    //         color: '#fff'
                    //     },
                    //     left: '25%',
                    //     bottom: '12%',
                    //     borderWidth: 1,
                    //     padding: 10,
                    //     seriesIndex: [0]
                    // },
                    visualMap: {
                        show: false, // 省级不显示
                        min: 0,
                        max: _this.findMaxVal(_this.provinceMapData),
                        left: '25%',
                        bottom: '12%',
                        text: ['高', '低'],           // 文本，默认为数值文本
                        textStyle: {
                            color: '#fff'
                        },
                        calculable: true,
                        seriesIndex: [0],
                        inRange: {
                            color: ['#b2c7ff', '#3067FF', '#234194']
                        }
                    },
                    series: [
                        {
                            name: 'categoryProvince',
                            type: 'map',
                            geoIndex: 0,
                            data: _this.provinceMapData,
                        }
                    ]
                });
                //移除省地图的点击事件
                _this.provinceMap.off('click');
                //点击省各市动态获取右边学校列表
                _this.provinceMap.on('click', function (params) {
                    //重置分页信息
                    _this.pageParams.total = 0;
                    _this.pageParams.page = 1;
                    _this.pageParams.pageCount = 0;
                    //根据市code获取学校班级使用数排序列表
                    _this.currentCityCode = params.data.code;
                    _this.getSchoolUseList(_this.currentProvinceCode, params.data.code);
                });
            },
            /**
             * 加载中国地图
             */
            loadChinaMap() {
                let _this = this;
                _this.$refs.chinaMapRef.style.height = window.innerHeight - 200 + 'px';
                _this.map = this.$echarts.init(document.getElementById('china_map'));
                _this.map.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            if (params.seriesType === 'map') {
                                // 9段线
                                if (params.name == '') {
                                    return;
                                }
                                if (!isNaN(params.value)) {
                                    return params.name + ' : ' + params.value;
                                } else {
                                    return params.name + ' : 0';
                                }
                            } else if (params.seriesType === 'scatter') {
                                return params.name + ' : ' + params.value[2];
                            } else if (params.seriesType === 'effectScatter') {
                                return params.name + ' : ' + params.value[2];
                            } else {
                                return '暂无数据';
                            }
                        }
                    },
                    geo: {
                        map: 'china',
                        roam: false,
                        top: '0',
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: '#fff'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                // areaColor: '#182C64',
                                areaColor: '#b2c7ff',
                                borderColor: 'rgba(0, 0, 0, 0.2)'
                            }
                        },
                        emphasis: {
                            label: {
                                color: '#fff'
                            },
                            itemStyle: {
                                areaColor: '#29ACE2',
                            }
                        }
                    },
                    // 视觉映射组件
                    visualMap: {
                        min: 0,
                        max: _this.findMaxVal(_this.chinaData),
                        left: '25%',
                        bottom: '12%',
                        text: ['高', '低'],           // 文本，默认为数值文本
                        textStyle: {
                            color: '#fff'
                        },
                        calculable: true,
                        seriesIndex: [1],
                        inRange: {
                            color: ['#b2c7ff', '#3067FF', '#234194']
                        }
                    },
                    series: [
                        {
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            geoIndex: 0,
                            data: _this.convertData(_this.chinaData),
                            symbolSize: 12,
                            showEffectOn: 'render',
                            rippleEffect: {
                                brushType: 'stroke'
                            },
                            animation: true,
                            label: {
                                show: true,
                                normal: {
                                    formatter: '{b}',
                                    position: 'top',
                                    show: true,
                                    textStyle: {
                                        color: '#fff'
                                    }
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#2AEFF1',
                                    shadowBlur: 10,
                                    shadowColor: '#333'
                                }
                            },
                            zlevel: 1
                        },
                        {
                            name: 'categoryChina',
                            type: 'map',
                            geoIndex: 0,
                            data: _this.chinaData
                        }
                    ]
                });

                //执行父页面的数字滚动加载
                _this.$emit('scroll-total-num');

                //点击中国地图弹出省地图
                _this.map.on('click', function (params) {
                    console.log(params)
                    _this.pageParams.total = 0;
                    _this.pageParams.page = 1;
                    _this.pageParams.pageCount = 0;
                    _this.openProvinceMap(params)
                });
            },
            /**
             * 打开省地图
             */
            openProvinceMap: function (param) {
                let _this = this;
                if (!param.name || param.name === '台湾' || param.name === '香港' || param.name === '澳门') {
                    return;
                }
                if (!_this.provinceMap) {
                    _this.provinceMap = _this.$echarts.init(document.getElementById('province_map'));
                }
                // 保存省份的名字
                _this.currentProvinceName = param.name;

                //保存省份的code
                _this.currentProvinceCode = param.data.code;

                //根据省code 获取各市数据
                _this.getCityData(param.data.code);

                //根据省code获取学校班级使用数排序列表
                _this.getSchoolUseList(param.data.code, '');

                //遍历取到provincesText 中的下标  去拿到对应的省json
                for (var i = 0; i < _this.provincesText.length; i++) {
                    if (param.name === _this.provincesText[i]) {
                        //动态加载省地图
                        _this.initProviceMap(_this.provinces[i], _this.provincesText[i]);
                        break;
                    }
                }

                _this.$nextTick(() => {
                    // 打开弹窗
                    _this.isShowProvince = true;
                });
            },
            /**
             * 根据省code 获取各市数据
             */
            async getCityData(provinceCode) {
                let _this = this;
                let params = {
                    province: provinceCode,
                    from: _this.fromTag == 1 ? '' : 'tempSchool'
                }
                let resultData = await findCityData(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                //学校数据
                if (_this.typeTag === 1) {
                    _this.provinceMapData = resultData.schoolsList;
                } else if (_this.typeTag === 2) {
                    //用户数据
                    _this.provinceMapData = resultData.usersLiset;
                }
                console.log(_this.provinceMapData);
            },
            /**
             * 根据省code/市code 获取该省/市学校使用情况列表
             */
            async getSchoolUseList(provinceCode, cityCode) {
                let _this = this;
                let params = {
                    province: provinceCode,
                    city: cityCode,
                    keyWord: _this.filters.keyWord,
                    from: _this.fromTag == 1 ? '' : 'tempSchool',
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                }
                let resultData = await findSchoolUserList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                //按学校班级使用数排序列表
                if (_this.typeTag === 1) {
                    _this.schoolUseData = resultData.gradeList;
                    _this.pageParams.total = resultData.gradeTotal;
                    _this.pageParams.pageCount = Math.ceil(resultData.gradeTotal / _this.pageParams.limit);
                } else if (_this.typeTag === 2) {
                    //按学校用户数量排序列表
                    _this.schoolUseData = resultData.userGradeLiset;
                    _this.pageParams.total = resultData.userTotal;
                    _this.pageParams.pageCount = Math.ceil(resultData.userTotal / _this.pageParams.limit);

                }
            },
            /**
             * 点击查看学校数据展板
             */
            lookSchoolDashBoard(schoolId) {
                let routeData = this.$router.resolve({
                    name: schoolId=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    params: {
                        schoolId: schoolId
                    },query:{
                        tokenId:this.$store.getters.token
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        mounted() {
            let _this = this;

            //初始化地图经纬度
            _this.getGeoData();

            //加载中国地图
            _this.loadChinaMap();

            // 更新地图
            window.addEventListener('resize', function () {
                _this.$refs.chinaMapRef.style.height = window.innerHeight - 200 + 'px';
                _this.map.resize();
            });
        }
    };
</script>

<style lang="scss" scoped>

    @import "../../../style/map";

    .map-container {
        position: relative;
        box-sizing: border-box;
        padding: 0px 22px 0px 22px;
    }

    .panel-box {
        background-image: url("../../../assets/images/map/box-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%
    }

</style>
